<template>
  <select
    class="button-select-control"
    :value="selectedId"
    @input="$emit('select', $event.target.value)">
    <option :value="null">
      {{ nullSelection }}
    </option>
    <option
      v-for="selection in selections"
      :key="selection.id"
      :value="selection.id">
      {{ selection.name }}
    </option>
  </select>
</template>

<script>
export default {
  name: 'ButtonSelect',
  model: {
    prop: 'selectedId',
    event: 'select',
  },
  props: {
    selectedId: {
      type: String,
      default: null,
    },
    nullSelection: {
      type: String,
      default: '-',
    },
    selections: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.button-select-control {
  padding: 2px 4px;
  width: 250px;
  color: #808b9c;
  border-color: rgba(#808b9c, 0.5);
  border-radius: 2px;
}
</style>
